import { useTranslation } from "react-i18next";
import Badge from "react-bootstrap/Badge";
import { AdminListMain } from "../../../../SharedComponents/ListView";

export default function RowInfo({ inventory }) {
  const { t } = useTranslation();

  return (
    <AdminListMain>
      <span className="admin-list-id">{inventory.id}</span>
      <span className="admin-list-title">{inventory.name}</span>
      <span className="admin-list-meta">
        {inventory.scopes?.length} {t("scope")}
      </span>
      {inventory.assessments?.map((assessment, m) => (
        <Badge key={"te" + m} bg={assessment.isB2b ? "success" : "secondary"}>
          {assessment.name}
        </Badge>
      ))}
    </AdminListMain>
  );
}
